import { useQuery } from "@tanstack/react-query";
import { fetchUnusedCustomValues } from "PFCore/services/admin/custom_values";
import { Collection, CustomValue, Id } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { customValueKeys } from "./query_keys";

export type UnusedCustomValuesResponse = Collection<CustomValue[]>;

export const useUnusedCustomValues = (customTypeId: Id, options?: QueryOptions<UnusedCustomValuesResponse>) =>
  useQuery<UnusedCustomValuesResponse>({
    queryKey: customValueKeys.unused(customTypeId),
    queryFn: () => fetchUnusedCustomValues(customTypeId),
    retry: false,
    ...options
  });
